module.exports = __webpack_public_path__ + "static/media/FLUXO-CG-PAN.68d1d75f.jpg";